// extracted by mini-css-extract-plugin
module.exports = {"content":"Header_content__2rZ1u","smallScreenOnly":"Header_smallScreenOnly__37kCs"};